(function() {
  "use strict";
  angular.module("marketPlace.invites", []);
})();
